import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { Redirect } from 'react-router';
import { logout, Logout } from 'src/actions/authentication/login/Login.actions';

interface StateProps {
  isLogged: boolean;
}

interface OwnProps {
  // tslint:disable-next-line:no-any
  exact: boolean;
  path: string;
}

interface DispatchProps {
  logout: () => Logout;
}

interface Props extends StateProps, OwnProps, DispatchProps {
}

class IsLoggedRoute extends React.Component<Props> {

  public render(): React.ReactNode {
    if (this.props.isLogged) {
      return (this.props.children);
    }

    this.props.logout();
    return <Redirect to={{pathname: '/'}}/>;
  }

}

const mapDispatchToProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => ({
  logout: (): Logout => (
    dispatch(logout())
  ),
});
                                           
const mapStateToProps = (state: RootState): StateProps => ({
  isLogged: state.authentication.isLogged
});

export default connect(mapStateToProps, mapDispatchToProps)(IsLoggedRoute);



// WEBPACK FOOTER //
// ./src/modules/commons/is-logged-route/IsLoggedRoute.tsx